// extracted by mini-css-extract-plugin
module.exports = {"box":"Login_box_3wfNx","title":"Login_title_2R46r","message":"Login_message_VjFC_","fieldset":"Login_fieldset_1H0ML","error":"Login_error_1LjcT","button":"Login_button_1Muk2"};